export default __webpack_public_path__ + "static/media/werewolfclose.0b8555a8.mp3";